export const environment = {
  production: true,
  baseUrl: 'https://wisee.srdi.net/api',
  boPath: '/bo',
};
